import type { DefaultOptions } from '@tanstack/react-query'

/**
 * Configurazione della cache delle query, unica per app e test.
 *
 * Sta qui e non dentro App.tsx per un motivo concreto: i test che usavano un
 * QueryClient "di comodo" (staleTime 0) risultavano verdi mentre in uso reale
 * la stessa schermata era rotta, perché con lo staleTime vero una rilettura
 * entro 30 secondi torna dalla cache invece che dal server (bug 16/09 sulla
 * creazione del punto vendita dal contratto). Importando queste opzioni, un
 * test non può più divergere dall'app.
 */
export const QUERY_DEFAULT_OPTIONS: DefaultOptions = {
  queries: { staleTime: 30_000, retry: 1 },
}

/** Le stesse opzioni dell'app, ma senza i retry: nei test un errore deve emergere subito. */
export const QUERY_DEFAULT_OPTIONS_TEST: DefaultOptions = {
  queries: { ...QUERY_DEFAULT_OPTIONS.queries, retry: false },
}
